import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionStorageKeys } from 'src/app/core/enums/SessionStorageKeys';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ExistingService } from './funnel.service';

export interface ExistingServiceByLicensePlate {
  [licensePlate: string]: ExistingService[];
}

@Injectable({
  providedIn: 'root'
})
export class ExistingServiceByLicensePlateService {


  private readonly storageKey = SessionStorageKeys.ExistingServiceByLicensePlate;

  private readonly cache$ = new BehaviorSubject<ExistingServiceByLicensePlate>({});

  constructor(
    private readonly sessionStorageService: SessionStorageService
  ) {
    this.loadFromSession();
  }

  // -------------------------------------
  // Load / Save
  // -------------------------------------

  private loadFromSession() {
    const raw = this.sessionStorageService.get<ExistingServiceByLicensePlate>(this.storageKey);

    try {
      this.cache$.next(raw ?? {});
    } catch {
      this.cache$.next({});
    }
  }

  private saveToSession() {
    this.sessionStorageService.set(this.storageKey, this.cache$.value);
  }

  // -------------------------------------
  // Public API
  // -------------------------------------

  /** Observable para que el componente escuche cambios */
  get changes$() {
    return this.cache$.asObservable();
  }

  getExtra(licensePlate: string) {
    return this.cache$.value[licensePlate] ?? null;
  }

  setExtra(licensePlate: string, data: ExistingService[] | null) {
    if (!data) { return }
    const updated = {
      ...this.cache$.value,
      [licensePlate.toLocaleLowerCase()]: data
    };
    this.cache$.next(updated);
    this.saveToSession();
  }

  deleteExtra(licensePlate: string) {
    const updated = { ...this.cache$.value };
    delete updated[licensePlate];
    this.cache$.next(updated);
    this.saveToSession();
  }

  clear() {
    this.cache$.next({});
    this.sessionStorageService.remove(this.storageKey);
  }

  getAll(): ExistingServiceByLicensePlate {
    return { ...this.cache$.value };
  }
}